import React, { useEffect, useRef } from "react";

const TypedLite = ({
  strings = [],
  typeSpeed = 50,
  backSpeed = 40,
  backDelay = 1500,
  loop = true,
}) => {
  const elRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || !strings || strings.length === 0) return;
    let cancelled = false;
    let wordIndex = 0;
    let charIndex = 0;
    let typing = true;

    const schedule = (fn, ms) => setTimeout(() => { if (!cancelled) fn(); }, ms);

    const step = () => {
      if (cancelled) return;
      const current = strings[wordIndex] || "";

      if (typing) {
        charIndex++;
        elRef.current.textContent = current.slice(0, charIndex);
        if (charIndex >= current.length) {
          typing = false;
          schedule(() => requestAnimationFrame(step), backDelay);
          return;
        }
        schedule(() => requestAnimationFrame(step), typeSpeed);
      } else {
        charIndex--;
        elRef.current.textContent = current.slice(0, charIndex);
        if (charIndex <= 0) {
          typing = true;
          wordIndex = wordIndex + 1;
          if (wordIndex >= strings.length) {
            if (loop) wordIndex = 0;
            else return;
          }
          schedule(() => requestAnimationFrame(step), typeSpeed);
          return;
        }
        schedule(() => requestAnimationFrame(step), backSpeed);
      }
    };

    // start
    requestAnimationFrame(step);

    return () => {
      cancelled = true;
    };
  }, [strings, typeSpeed, backSpeed, backDelay, loop]);

  return <span ref={elRef} />;
};

export default TypedLite;
